<template>
  <div class="user-modal-wrapper">
    <div
      class="user-modal"
      :class="{ 'user-modal-small': limitedFunctionality }"
    >
      <section class="tabs-wrapper">
        <div class="tabs tabs--bottom">
          <p
            class="tab tab--main"
            :class="{ 'tab-active': showcontent === 'userInfo' }"
            @click="toggleContent('userInfo')"
          >
            Основна информация
          </p>
          <p
            class="tab tab--main"
            :class="{ 'tab-active': showcontent === 'user_inventory' }"
            @click="toggleContent('user_inventory')"
          >
            Служебен инвентар и ЛПС
          </p>
        </div>
      </section>
      <transition
        :name="showcontent === 'userInfo' ? 'slide-left' : 'slide-right'"
        mode="out-in"
      >
        <form v-if="showcontent === 'userInfo'">
          <div class="row">
            <!-- USERNAME -->
            <div class="input-and-label">
              <label for="userModalUsername" class="input-label"
                >Потребителско име</label
              >
              <div class="input-wrapper" :class="{ invalid: !isUsernameValid }">
                <span class="mck">B</span>
                <input
                  id="userModalUsername"
                  type="text"
                  placeholder="Потребителско име"
                  v-model="user.username"
                  @keyup="(isUsernameValid = true), formatUsername()"
                  @keydown.enter.prevent
                  :disabled="limitedFunctionality"
                />
                <span v-if="limitedFunctionality" class="disabled">A</span>
              </div>
            </div>

            <!-- NAME -->
            <div class="input-and-label">
              <label for="userModalName" class="input-label">Име</label>
              <div class="input-wrapper" :class="{ invalid: !isNameValid }">
                <span class="mck2">G</span>
                <input
                  id="userModalName"
                  type="text"
                  placeholder="Име"
                  v-model="user.name"
                  @keyup="isNameValid = true"
                  @keydown.enter.prevent
                />
              </div>
            </div>
          </div>
          <div class="row">
            <!-- EMAIL -->
            <div class="input-and-label">
              <label for="userModalEmail" class="input-label">E-mail</label>
              <div class="input-wrapper" :class="{ invalid: !isEmailValid }">
                <span class="mck2">w</span>
                <input
                  id="userModalEmail"
                  placeholder="E-mail"
                  v-model="user.email"
                  @keyup="isEmailValid = true"
                  @keydown.enter.prevent
                />
              </div>
            </div>
            <!-- PASSWORD -->
            <div class="input-and-label">
              <label for="userModalPassword" class="input-label">Парола</label>
              <div class="input-wrapper" :class="{ invalid: !isPasswordValid }">
                <span class="mck2">z</span>
                <input
                  id="userModalPassword"
                  type="password"
                  placeholder="Парола"
                  :disabled="user.permissions.isExternalWorker"
                  v-model="user.password"
                  @keyup="isPasswordValid = true"
                  @keydown.enter.prevent
                />
              </div>
            </div>
          </div>
          <hr />
          <div class="row" v-if="!limitedFunctionality">
            <div class="new-input-wrapper" v-if="user.position">
              <label class="input-label">Длъжност</label>
              <div class="new-input">
                <span class="mck2">s</span>
                <!-- NOT SELECTED -->
                <input
                  v-if="!user.position._id"
                  type="text"
                  placeholder="Име на длъжност"
                  @focus="getPositions(), openDropdown(0)"
                  @blur="closeDropdown(0)"
                  v-model="searchPositions"
                />
                <!-- SELECTED -->
                <input
                  v-else
                  type="text"
                  placeholder="Име на длъжност"
                  @focus="getPositions(), openDropdown(0)"
                  v-model="user.position.name"
                  @blur="closeDropdown(0)"
                  :disabled="user.position._id"
                />
                <span
                  v-if="user.position._id"
                  class="clear"
                  @click="resetSelectedPosition()"
                  >F</span
                >
                <span
                  v-else
                  class="arrow"
                  :class="{ 'arrow-reversed': openedDropdown[0] }"
                  >K</span
                >
                <!-- <span class="disabled">A</span> -->
              </div>
              <!-- DROP-DOWN COMPANIES -->
              <div
                class="new-input-dropdown"
                :class="{ 'new-input-dropdown-active': openedDropdown[0] }"
              >
                <ul v-if="positions.length">
                  <li
                    v-for="p in filteredPositions"
                    :key="p._id"
                    @click="user.position = p"
                  >
                    {{ p.name }}
                  </li>
                  <li
                    class="no-results"
                    v-if="searchPositions && !filteredPositions.length"
                  >
                    Няма такава длъжност.
                    <br />Длъжностите се добавят предварително в подтаб
                    Длъжности
                  </li>
                </ul>
              </div>
            </div>
            <!-- GROUP -->
            <div class="new-input-wrapper" v-if="user.group">
              <label class="input-label">Група</label>
              <div class="new-input">
                <span class="mck2">D</span>
                <!-- NOT SELECTED -->
                <input
                  v-if="!user.group._id"
                  type="text"
                  placeholder="Име на група"
                  @focus="getGroups(), openDropdown(1)"
                  @blur="closeDropdown(1)"
                  v-model="searchGroups"
                />
                <!-- SELECTED -->
                <input
                  v-else
                  type="text"
                  placeholder="Име на група"
                  @focus="getGroups(), openDropdown(1)"
                  v-model="user.group.name"
                  @blur="closeDropdown(1)"
                  :disabled="user.group._id"
                />
                <span
                  v-if="user.group._id"
                  class="clear"
                  @click="resetSelectedGroup()"
                  >F</span
                >
                <span
                  v-else
                  class="arrow"
                  :class="{ 'arrow-reversed': openedDropdown[1] }"
                  >K</span
                >
                <!-- <span class="disabled">A</span> -->
              </div>
              <!-- DROP-DOWN COMPANIES -->
              <div
                class="new-input-dropdown"
                :class="{ 'new-input-dropdown-active': openedDropdown[1] }"
              >
                <ul v-if="groups.length">
                  <li
                    v-for="g in filteredGroups"
                    :key="g._id"
                    @click="selectGroup(g)"
                  >
                    {{ g.name }}
                  </li>
                  <li
                    class="no-results"
                    v-if="searchGroups && !filteredGroups.length"
                  >
                    Няма такава група.
                    <br />Групите се добавят предварително в подтаб Групи
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="input-and-label">
              <!-- PHONE -->
              <label for="userPhone" class="input-label">Телефон</label>
              <div class="input-wrapper">
                <span class="mck2">v</span>
                <input
                  id="userPhone"
                  placeholder="Телефон"
                  v-model="user.phone"
                  @keydown.enter.prevent
                />
              </div>
            </div>
            <!-- COMMENT -->
            <div class="input-and-label">
              <label for="userModalComment" class="input-label">Коментар</label>
              <div class="input-wrapper">
                <span class="mck2">u</span>
                <input
                  id="userModalComment"
                  placeholder="Кратък коментар"
                  v-model="user.comment"
                  @keydown.enter.prevent
                />
              </div>
            </div>
          </div>
          <template v-if="!limitedFunctionality">
          </template>
          <template v-if="!limitedFunctionality">
            <hr />
            <label class="input-label">Основни роли и разрешения</label>

            <div class="user-modal-permissions">
              <label
                v-for="role of mainRoles"
                :key="role._id"
                :class="{
                  'checkbox-wrapper--disabled': isRoleDisabled(role),
                }"
                class="checkbox-wrapper"
              >
                {{ role.name }}
                <input
                  @click="toggleRole(role)"
                  type="checkbox"
                  :disabled="isRoleDisabled(role)"
                  :checked="isRoleChecked(role)"
                />
                <span class="checkmark"></span>
              </label>
            </div>
            <hr />
            <div class="roles-wrapper">
              <label class="input-label">Допълнителни роли</label>

              <label
                v-for="role of extraRoles"
                :key="role._id"
                class="checkbox-wrapper"
              >
                {{ role.name }}
                <input
                  @click="toggleRole(role)"
                  type="checkbox"
                  :checked="isRoleChecked(role)"
                />
                <span class="checkmark"></span>
              </label>
            </div>
          </template>
        </form>
        <section class="table-wrapper" v-else>
          <table class="table table--inventory">
            <thead>
              <tr>
                <th>ИНВЕНТАР</th>
                <th>МАРКА/МОДЕЛ</th>
                <th>СЕРИЕН НОМЕР</th>
                <th>ЗАЧИСЛЕН НА</th>
                <th>ВЪРНАТ НА</th>
                <th>БРАКУВАН НА</th>
                <th>ЗАБЕЛЕЖКА</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="!user.inventories.length">
                <td colspan="7" style="text-align: center">
                  няма намерени инвентари
                </td>
              </tr>
              <tr v-for="inv of user.inventories" :key="inv._id">
                <td>{{ inv.name }}</td>
                <td>{{ inv.brand }}</td>
                <td>{{ inv.serialNumber }}</td>
                <td>
                  {{ inv.date | formatDate }}
                </td>
                <td>
                  {{ inv.returnedOn | formatDate }}
                </td>
                <td>
                  {{ inv.scrappedOn | formatDate }}
                </td>
                <td>{{ inv.note }}</td>
              </tr>
            </tbody>
          </table>
        </section>
      </transition>
      <div class="user-modal-actions">
        <section class="user-switches">
          <div class="switch-container" v-if="!limitedFunctionality">
            <label class="switch">
              <input type="checkbox" v-model="user.isActive" />
              <span class="slider"></span>
            </label>
            <label v-if="user.isActive">Активен</label>
            <label v-else>Неактивен</label>
          </div>
          <div
            title="Само работниците с тази отметка ще бъдат видими за подизпълнителя при преглед на отчет или справка"
            class="switch-container"
            v-if="!limitedFunctionality"
          >
            <label class="switch">
              <input type="checkbox" v-model="user.isVisibleMain" />
              <span class="slider"></span>
            </label>
            <label>Видим</label>
          </div>
          <div v-else>
            <!-- JUST AND EMPTY DIV FOR THE SPACE-BETWEEN RULE TO WORK -->
          </div>
        </section>
        <div class="btns">
          <button class="btn btn-close" @click.prevent="closeModal(false)">
            <span class="mck">F</span>
            Отказ
          </button>
          <button
            v-if="!idToEdit"
            class="btn btn-new"
            type="submit"
            value="Submit"
            @click.prevent="register"
          >
            <span class="mck">B</span>
            Създай
          </button>
          <button
            v-else
            class="btn btn-new"
            type="submit"
            value="Submit"
            @click.prevent="edit"
          >
            <span class="mck">B</span>
            Редактирай
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getAccess } from "../mixins/getAccess.js";
import log from "../mixins/log.js";
export default {
  mixins: [log],
  props: ["idToEdit", "limitedFunctionality"],
  computed: {
    ...mapGetters(["getUser"]),
    filteredPositions() {
      return this.positions.filter((p) => {
        return p.name
          .toLowerCase()
          .includes(this.searchPositions.toLowerCase());
      });
    },
    filteredGroups() {
      return this.groups.filter((g) => {
        return g.name.toLowerCase().includes(this.searchGroups.toLowerCase());
      });
    },
    mainRoles() {
      return this.roles.length ? this.roles.filter((r) => r.isMain) : [];
    },
    extraRoles() {
      return this.roles.length ? this.roles.filter((r) => !r.isMain) : [];
    },
  },
  data() {
    return {
      openedDropdown: [false, false],
      positions: [],
      groups: [],
      searchPositions: "",
      showcontent: "userInfo",
      searchGroups: "",
      isUsernameValid: true,
      isPasswordValid: true,
      isNameValid: true,
      isEmailValid: true,
      roles: {},
      permissionIndicators: {
        admin: "isAdmin",
        superadmin: "isSuperAdmin",
        hr: "isHR",
        reporter: "isReporter",
        worker: "isWorker",
        external: "isExternalWorker",
      },
      user: {
        username: "",
        password: "",
        email: "",
        name: "",
        phone: "",
        position: { _id: "" },
        group: { _id: "" },
        comment: "",
        isActive: true,
        isVisible: false,
        roles: [],
        permissions: {
          isSuperAdmin: false,
          isAdmin: false,
          isReporter: false,
          isHR: false,
          isWorker: true,
          isExternalWorker: false,
          isVisible: false,
        },
      },
    };
  },
  methods: {
    isRoleDisabled(r) {
      if (r.indicator === "superadmin" || r.indicator === "hr") {
        return !this.user.permissions.isAdmin;
      }
    },
    toggleContent(content) {
      let accessName =
        content === "userInfo" ? "users_info" : "users_inventory_own";

      if (content === "user_inventory" && this.getUser._id !== this.idToEdit) {
        accessName = "users_inventory_all";
      }

      if (getAccess(accessName, "users", true)) {
        this.showcontent = content;
      }
    },
    toggleRole(r) {
      if (r.isMain) {
        let permision = this.permissionIndicators[r.indicator];
        this.user.permissions[permision] = !this.user.permissions[permision];

        // cant be superadmin or hr without being admin
        if (permision === "isAdmin" && !this.user.permissions[permision]) {
          this.user.permissions.isSuperAdmin = false;
          this.user.permissions.isHR = false;

          // remove both roles if present
          for (let indicator of ["superadmin", "hr"]) {
            const indexOfRole = this.user.roles.findIndex(
              (role) => role.indicator === indicator
            );
            if (indexOfRole !== -1) {
              this.user.roles.splice(indexOfRole, 1);
            }
          }
        }
      }

      if (this.user.roles.some((role) => role._id === r._id)) {
        const indexOfRole = this.user.roles.findIndex(
          (role) => role._id === r._id
        );

        if (indexOfRole !== -1) {
          this.user.roles.splice(indexOfRole, 1);
        }
      } else {
        this.user.roles.push(r);
      }
    },
    isRoleChecked(r) {
      if (r.isMain) {
        let permision = this.permissionIndicators[r.indicator];
        return this.user.permissions[permision];
      }

      return (
        this.user.roles.length &&
        this.user.roles.some((role) => role._id === r._id)
      );
    },
    // Open dropdown. Depends on index (hard coded in template)
    openDropdown(i) {
      this.$set(this.openedDropdown, i, true);
    },
    // Close dropdown. Depends on index (hard coded in template)
    closeDropdown(i) {
      setTimeout(() => {
        this.$set(this.openedDropdown, i, false);

        if (this.searchPositions && !this.user.position._id) {
          this.$snotify.warning("Трябва да изберете длъжността");
        }
        if (this.searchGroups && !this.user.group._id) {
          this.$snotify.warning("Трябва да изберете групата");
        }

        this.searchPositions = "";
        this.searchGroups = "";
      }, 100);
    },
    getPositions() {
      this.$http
        .get(`${process.env.VUE_APP_BASE_URI}/position?active=true`)
        .then((response) => {
          this.positions = response.data;
        });
    },
    getGroups() {
      this.$http
        .get(`${process.env.VUE_APP_BASE_URI}/group?active=true`)
        .then((response) => {
          this.groups = response.data;
        });
    },
    selectGroup(g) {
      this.user.group = g;
    },
    resetSelectedPosition() {
      this.user.position = { _id: "" };
    },
    resetSelectedGroup() {
      this.user.group = { _id: "" };
    },
    async getSpecificUser(id) {
      try {
        let res = await this.$http.get(
          `${process.env.VUE_APP_BASE_URI}/auth/users/${id}`
        );
        this.user = res.data;
      } catch (err) {
        console.log(err);
      }
    },
    validateEmail(email) {
      const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    validateUsername(username) {
      if (!username.length) {
        return false;
      }
      const re = /^[a-z0-9_.-]*$/;
      if (!username.match(re)) {
        return false;
      }
      return true;
    },
    // Reformat username - only lowercase latin letters, numbers, dot, underscore and dash
    formatUsername() {
      this.user.username = this.user.username
        .replace(/[^A-Za-z0-9-._]/g, "")
        .toLowerCase();
    },
    adminChecked(c) {
      if (!c) {
        this.user.permissions.isSuperAdmin = false;
        this.user.permissions.isHR = false;
      }
    },
    checkForm() {
      if (!this.validateUsername(this.user.username)) {
        this.isUsernameValid = false;
      }
      if (!this.user.password && !this.idToEdit) {
        this.isPasswordValid = false;
      }
      if (!this.user.name) {
        this.isNameValid = false;
      }
      if (this.user.email) {
        if (this.user.email.length && !this.validateEmail(this.user.email)) {
          this.isEmailValid = false;
        }
      }
      if (
        this.user.permissions.isSuperAdmin &&
        !this.user.permissions.isAdmin
      ) {
        this.$snotify.error(
          "Не може потребителя да е главен администратор без да е администратор"
        );
        return false;
      }
      if (this.user.permissions.isHR && !this.user.permissions.isAdmin) {
        this.$snotify.error(
          "Не може потребителя да е ЧР без да е администратор"
        );
        return false;
      }

      // If everything is valid
      if (
        this.isUsernameValid &&
        this.isPasswordValid &&
        this.isNameValid &&
        this.isEmailValid
      ) {
        return true;
      }
      // if not
      return false;
    },
    register() {
      if (this.checkForm()) {
        let userForRequest = this.user;
        // if (!userForRequest.email.length) {
        //   delete userForRequest.email;
        // }
        this.$http
          .post(`${process.env.VUE_APP_BASE_URI}/auth/register`, userForRequest)
          .then(() => {
            this.$snotify.success("Успешно регистрирахте нов потребител!");
            this.newLog("newUser", this.user.username);
            this.closeModal(true);
          })
          .catch((err) => {
            if (err.response) {
              this.$snotify.error(err.response.data);
            } else {
              console.log(err);
            }
          })
          .then(() => {});
      } else {
        // TODO: Do something
      }
    },
    edit() {
      if (this.checkForm()) {
        this.$http
          .put(
            `${process.env.VUE_APP_BASE_URI}/auth/users/${this.idToEdit}`,
            this.user
          )
          .then((res) => {
            this.$snotify.success("Промените са записани успешно!");
            // IF THE CURRENTLY LOGGED USER CHANGED HIS OWN ROLE IT LOGGES HIM OUT
            if (this.idToEdit === this.$store.state.user._id) {
              const oldPermissions = this.$store.state.user.permissions;
              const newPermissions = res.data.user.permissions;
              if (
                !(
                  oldPermissions.isSuperAdmin === newPermissions.isSuperAdmin &&
                  oldPermissions.isAdmin === newPermissions.isAdmin &&
                  oldPermissions.isReporter === newPermissions.isReporter &&
                  oldPermissions.isWorker === newPermissions.isWorker &&
                  oldPermissions.isExternalWorker ===
                    newPermissions.isExternalWorker &&
                  oldPermissions.isVisible === newPermissions.isVisible &&
                  this.$store.state.user.isActive === res.data.user.isActive
                )
              ) {
                this.$store
                  .dispatch("logout")
                  .then(() => this.$router.push("/login"))
                  .catch((err) => console.log(err));
              }
            }
            this.newLog("editUser", this.user.username);
            this.closeModal(true);
          })
          .catch((error) => {
            if (typeof error.response.data === "string") {
              this.$snotify.error(error.response.data);
            } else {
              console.log(error.response);
              this.$snotify.error("Нещо се обърка! Моля опитайте отново.");
            }
          })
          .then(() => {});
      } else {
        // TODO: Do something
      }
    },
    async getRoles() {
      try {
        let res = await this.$http.get(`${process.env.VUE_APP_BASE_URI}/roles`);
        this.roles = res.data;

        // set initial roles to the rules that dont have them
        Object.entries(this.permissionIndicators).forEach(([key, value]) => {
          if (this.user.permissions[value]) {
            let role = res.data.find((s) => s.indicator === key);

            if (role && !this.user.roles.some((r) => r._id === role._id)) {
              this.user.roles.push(role);
            }
          }
        });
      } catch (err) {
        console.log(err);
      }
    },
    closeModal(isEdited) {
      // isEdited = true => means something is changed
      // isEdited = false => just close the modal
      this.$parent.$emit("closeUserModal", { isEdited: isEdited });
    },
    handleEvents(e) {
      if (e.code === "Enter") {
        if (this.idToEdit) {
          this.edit();
        } else {
          this.register();
        }
      } else if (e.code === "Escape") {
        this.closeModal(false);
      }
    },
  },
  async mounted() {
    if (this.idToEdit) {
      await this.getSpecificUser(this.idToEdit);
    }
    await this.getRoles();
    if (this.idToEdit === this.$store.state.user._id) {
      if (this.limitedFunctionality) {
        this.$snotify.warning(
          "Внимание! При редакция на профила ви ще бъдете разлогнати от системата и ще трябва да влезете отново."
        );
      } else {
        this.$snotify.warning(
          "Внимание! Ако промените някое от собствените ви разрешения или статус ще бъдете разлогнати от системата."
        );
      }
    }
    window.addEventListener("keydown", this.handleEvents);
  },
  destroyed() {
    window.removeEventListener("keydown", this.handleEvents);
  },
};
</script>

<style scoped lang="scss">
.user-modal-wrapper {
  align-items: center;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10;
}
.tabs-wrapper {
  align-items: center;
  display: flex;
  justify-content: space-between;
}

form,
.table-wrapper {
  background: #fff;
  border-radius: 4px;
  border: 1px solid #d7dbe9;
  padding: 10px 20px;
  overflow: auto;
  height: 400px;
}

.table-wrapper {
  overflow: auto;

  .table {
    width: 100%;
  }
}
.user-switches {
  display: flex;
  gap: 15px;
}
.row {
  display: flex;
}
.input-and-label {
  width: 100%;
}
.new-input-wrapper {
  margin: 0;
  width: 100%;
}
.new-input-wrapper label {
  font-size: 12px;
}
.new-input-wrapper .new-input {
  margin: 0;
}
.new-input-dropdown {
  top: calc(100% + 10px);
}
.new-input-dropdown-active {
  height: 160px;
}
.row .input-and-label:not(:first-child),
.row .new-input-wrapper:not(:first-child) {
  margin-left: 20px;
}
.user-modal {
  // background-color: #fff;
  background: #f0f0f7;
  border-radius: 4px;
  /* border-top: 10px solid #6d2600; */
  display: flex;
  flex-direction: column;
  /* height: 60vh; */
  overflow: auto;
  padding: 10px 20px 0;
  width: 850px;
  -webkit-box-shadow: 10px 10px 204px -19px rgba(0, 0, 0, 0.52);
  -moz-box-shadow: 10px 10px 204px -19px rgba(0, 0, 0, 0.52);
  box-shadow: 10px 10px 204px -19px rgba(0, 0, 0, 0.52);
}
.user-modal-small {
  width: 600px;
}
.user-modal-permissions {
  background-color: #f4f4f4;
  border-radius: 4px;
  display: flex;
  justify-content: center;
}
.user-modal-actions {
  display: flex;
  justify-content: space-between;
  padding: 20px 0;
}
.roles-wrapper {
  display: flex;
  flex-direction: column;
  gap: 8px;
  .checkbox-wrapper {
    margin: initial;
  }
}
.invalid .mck {
  color: #d91313;
}
.invalid input {
  background-color: #f8dcdc;
  color: #d91313;
}
.invalid input::placeholder {
  color: #d91313;
}
.invalid input::placeholder {
  color: #d91313;
}
.invalid input::placeholder {
  color: #d91313;
}
.invalid input::placeholder {
  color: #d91313;
}
hr {
  border: 0;
  background-color: #707070;
  height: 1px;
  opacity: 0.2;
  margin: 20px 0 10px;
}
/* Responsive */
@media screen and (max-width: 900px) {
  .user-modal {
    width: 90%;
  }
}
@media screen and (max-width: 700px) {
  .user-modal.user-modal-small {
    width: 90%;
  }
}
@media screen and (max-width: 500px) {
  .user-modal-actions {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .switch-container {
    display: flex;
    justify-content: center;
    margin-bottom: 1em;
  }
  .btns {
    justify-content: center;
  }
  .user-modal-permissions {
    flex-direction: column;
  }
}
@media screen and (max-height: 550px) {
  .user-modal {
    height: 100%;
  }
  .user-modal.user-modal-small {
    height: 68%;
  }
}
@media screen and (max-height: 500px) {
  .user-modal.user-modal-small {
    height: 73%;
  }
}
@media screen and (max-height: 365px) {
  .user-modal.user-modal-small {
    height: 100%;
  }
}
</style>
